import JahcrHaveRightToWork from './JahcrHaveRightToWork.component';

export default JahcrHaveRightToWork;